/**
 * If the line starts with a text it is a label
 * @param {string} [text='']
 * @returns {object}
 */
export function createLabeledRecords(text = '') {
  let result = new Map(); // garanty the order of the keys
  let lines = text.split(/[\r\n]+/);
  let label = '';
  for (let line of lines) {
    if (line.startsWith(' ')) {
      // we continue the previous field
      let currentValue = result.get(label) || '';
      if (currentValue) currentValue += '\n';
      if (line.startsWith('  ')) line = line.slice(2);
      currentValue += line;
      result.set(label, currentValue);
    } else {
      // it is a new label
      label = line.replace(/:$/, '');
    }
  }
  return result;
}
